// Click-to-chat WhatsApp helper (no API keys needed).
const clean = (tel) => (tel || "").replace(/[^\d]/g, "");

export const waLink = (tel, message) => {
  const n = clean(tel);
  const text = encodeURIComponent(message || "");
  return n ? `https://wa.me/${n}?text=${text}` : `https://wa.me/?text=${text}`;
};

export const trackMessage = ({ nombre, tracking, estado, url }) =>
  `Hola ${nombre || ""}, su envío ${tracking || ""} está en estado: ${estado || ""}.` +
  (url ? ` Seguimiento: ${url}` : "");

export const openWhatsApp = (tel, message) => {
  window.open(waLink(tel, message), "_blank", "noopener,noreferrer");
};
